import type { AvisoRespondida } from '@/components/tarefas/AvisoAjudaRespondida';

export type TipoCartaoTarefa = 'atendimento' | 'respondida' | 'concluida';

/** Os avisos de tarefa que viram cartão no canto (não popup). */
export const tipoCartaoTarefa = (a: Pick<AvisoRespondida, 'titulo' | 'metadados'>): TipoCartaoTarefa | null => {
  const origem = a.metadados?.origem;
  if (origem === 'tarefa_atendimento_dono') return 'atendimento';
  if (origem === 'tarefa_atendimento_concluida') return 'concluida';
  if (origem === 'tarefa_ajuda_respondida' && !String(a.titulo || '').startsWith('📋')) return 'respondida';
  return null;
};
